import * as Types from '../../../generated/graphql';

import { CircleTopicFragment } from './topic.generated';
import { gql } from 'graphql.macro';
import { CircleTopicFragmentDoc } from './topic.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type FetchTopicsQueryVariables = Types.Exact<{
  seriesSlug: Types.Scalars['String'];
  cursor?: Types.Maybe<Types.Scalars['String']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type FetchTopicsQuery = (
  { __typename: 'Query' }
  & { circleSeriesBySlug?: Types.Maybe<(
    { __typename: 'CircleSeriesNode' }
    & Pick<Types.CircleSeriesNode, 'id' | 'name' | 'heroImage' | 'heroBackgroundColor' | 'description' | 'illustration' | 'shortDescription' | 'accessType'>
    & { topics: (
      { __typename: 'CircleTopicConnection' }
      & Pick<Types.CircleTopicConnection, 'totalCount'>
      & { pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<Types.PageInfo, 'endCursor' | 'hasNextPage'>
      ), edges: Array<Types.Maybe<(
        { __typename: 'CircleTopicEdge' }
        & Pick<Types.CircleTopicEdge, 'cursor'>
        & { node: (
          { __typename: 'CircleTopicNode' }
          & Pick<Types.CircleTopicNode, 'id'>
          & CircleTopicFragment
        ) }
      )>> }
    ) }
  )> }
);


export const FetchTopicsDocument = gql`
    query fetchTopics($seriesSlug: String!, $cursor: String, $limit: Int = 10) {
  circleSeriesBySlug(slug: $seriesSlug) {
    id
    name
    heroImage
    heroBackgroundColor
    description
    illustration
    shortDescription
    accessType
    topics(after: $cursor, first: $limit) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          ...CircleTopic
        }
      }
    }
  }
}
    ${CircleTopicFragmentDoc}`;

/**
 * __useFetchTopicsQuery__
 *
 * To run a query within a React component, call `useFetchTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTopicsQuery({
 *   variables: {
 *      seriesSlug: // value for 'seriesSlug'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchTopicsQuery(baseOptions: Apollo.QueryHookOptions<FetchTopicsQuery, FetchTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTopicsQuery, FetchTopicsQueryVariables>(FetchTopicsDocument, options);
      }
export function useFetchTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTopicsQuery, FetchTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTopicsQuery, FetchTopicsQueryVariables>(FetchTopicsDocument, options);
        }
export type FetchTopicsQueryHookResult = ReturnType<typeof useFetchTopicsQuery>;
export type FetchTopicsLazyQueryHookResult = ReturnType<typeof useFetchTopicsLazyQuery>;
export type FetchTopicsQueryResult = Apollo.QueryResult<FetchTopicsQuery, FetchTopicsQueryVariables>;